import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {QuickLinksComponent} from './quick-links.component';
import {GenericLinkModule} from '@spartacus/storefront';


@NgModule({
  declarations: [
    QuickLinksComponent
  ],
  imports: [
    CommonModule,
    GenericLinkModule,
  ],
  exports: [
    QuickLinksComponent
  ]
})
export class QuickLinksModule {
}
